import React, { Component, useDebugValue } from 'react';
import { Link } from 'react-router';
import { Row } from 'reactstrap';
import { FieldCol, FieldGroup, FieldInput, FieldLabel, FieldSelect, FieldTextarea } from '../../../../applications/contracts/Elements';
export default class EditInsuranceCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            insuranceCard: {},
            error: {}
        }
    }
    componentDidMount() {
        this.updateHdState(this.props.insuranceCard);
    }
    updateHdState = (insuranceCard) => {
        let data = Object.assign({}, insuranceCard);
        this.setState({
            insuranceCard: data
        });
    }
    updateForm = (type, value) => {
        if (['agreed_value_per_lease_agreement', 'depreciation_per_year', 'insurance_remarks'].includes(type)) {
            this.setState(prevState => ({
                insuranceCard: {
                    ...prevState.insuranceCard,
                    insurance_titan_extra_fields: {
                        ...prevState.insuranceCard?.insurance_titan_extra_fields,
                        [type]: value,
                    },
                },
            }));
        }
    }
    updateInsuranceCard = (e) => {
        e.preventDefault();
        const insurance_titan_extra_fields = { ...this.state.insuranceCard.insurance_titan_extra_fields };
        this.props.updateInsuranceCard({ insurance_titan_extra_fields });
    }
    render() {
        const { type } = this.props;
        const { insuranceCard } = this.state;
        return (
            <form onSubmit={(e) => this.updateInsuranceCard(e)}>
                <div style={{ height: (window.innerHeight - 170) + 'px', overflow: 'auto', marginBottom: '60px' }}>
                    <Row>
                        <FieldCol md="12">
                            <FieldGroup className="form-group">
                                <FieldLabel className="label">Agreed Value as per the Lease Agreement</FieldLabel>
                                <FieldInput
                                    value={insuranceCard?.insurance_titan_extra_fields?.agreed_value_per_lease_agreement || ''}
                                    type={type}
                                    keyParam="agreed_value_per_lease_agreement"
                                    updateField={this.updateForm}
                                    accept="number"
                                />
                            </FieldGroup>
                        </FieldCol>
                    </Row>
                    <Row>
                        <FieldCol md="12">
                            <FieldGroup className="form-group">
                                <FieldLabel className="label">Depreciation Per Year</FieldLabel>
                                <FieldInput
                                    value={insuranceCard?.insurance_titan_extra_fields?.depreciation_per_year || ''}
                                    type={type}
                                    keyParam="depreciation_per_year"
                                    updateField={this.updateForm}
                                />
                            </FieldGroup>
                        </FieldCol>
                    </Row>
                    <Row>
                        <FieldCol md="12">
                            <FieldGroup className="form-group">
                                <FieldLabel className="label">Remarks</FieldLabel>
                                <FieldTextarea
                                    value={insuranceCard?.insurance_titan_extra_fields?.insurance_remarks || ''}
                                    type={type}
                                    keyParam="insurance_remarks"
                                    updateField={this.updateForm}
                                    style={{ height: '87px' }}
                                    maxLength={255}
                                />
                            </FieldGroup>
                        </FieldCol>
                    </Row>
                </div>
                <div className="submit-block">
                    <input type="submit" className="primary-btn" value="Save Changes" />
                    <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
                </div>
            </form>
        )
    }
}
